import { makeStyles } from "@material-ui/core/styles";

export const useNotificationsStyles = makeStyles(theme => ({
  section: {
    paddingLeft: 0,
    color: "#FFFFFF",
    [theme.breakpoints.down("sm")]: {
      padding: "24px 16px",
      paddingBottom: "64px",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "24px 0",
    },
  },
  pageTitle: {
    color: "#FFFFFF",
    fontWeight: 700,
    fontSize: "32px",
    lineHeight: 1.2,
    marginBottom: "48px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
      marginBottom: "32px",
    },
  },
  categoryCard: {
    borderRadius: "16px",
    border: "none",
    background:
      "linear-gradient(135deg, rgba(255,255,255,0.04), rgba(255,255,255,0))",
    padding: "0",
    marginBottom: "48px",
    backdropFilter: "blur(10px)",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "32px",
    },
  },
  categoryHeader: {
    display: "flex",
    justifyContent: "space-between",
    gap: "16px",
    flexWrap: "wrap",
  },
  categoryHeaderInfo: {
    flex: 1,
    cursor: "pointer",
    outline: "none",
  },
  categoryTitle: {
    color: "#f06ec4",
    fontWeight: 600,
    fontSize: "22px",
    marginBottom: "8px",
  },
  categoryDescription: {
    color: "rgba(255, 255, 255, 0.7)",
    fontSize: "14px",
    maxWidth: "560px",
    lineHeight: 1.6,
  },
  categoryControls: {
    display: "flex",
    gap: "8px",
    alignItems: "flex-start",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      justifyContent: "flex-start",
    },
  },
  categoryActionButton: {
    borderRadius: "30px",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    background: "transparent",
    color: "#FFFFFF",
    padding: "6px 16px",
    fontSize: "13px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover:not(:disabled)": {
      borderColor: "#f06ec4",
      color: "#f06ec4",
    },
    "&:disabled": {
      opacity: 0.5,
      cursor: "not-allowed",
    },
  },
  categoryBody: {
    // marginTop: "8px",
  },
  categorySimpleTitle: {
    color: "#FFFFFF",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: 1.2,
    marginBottom: "16px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  tableHeader: {
    display: "flex",
    alignItems: "center",
    padding: "16px 24px",
    borderRadius: "12px",
    backgroundColor: "rgba(255, 255, 255, 0.05)",
    border: "1px solid rgba(255, 255, 255, 0.08)",
    marginBottom: "12px",
  },
  tableHeaderSticky: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    backdropFilter: "blur(12px)",
  },
  headerCellPrimary: {
    flex: 1,
    fontWeight: 600,
    fontSize: "14px",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    color: "rgba(255, 255, 255, 0.8)",
  },
  headerCell: {
    width: "140px",
    textAlign: "center",
    fontWeight: 600,
    fontSize: "14px",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    color: "rgba(255, 255, 255, 0.8)",
  },
  tableBody: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  tableRow: {
    display: "flex",
    alignItems: "center",
    padding: "16px",
    borderRadius: "12px",
    border: "none",
    backgroundColor: "#131313",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "12px",
      padding: "8px",
    },
  },
  rowInfo: {
    flex: 1,
  },
  rowTitleWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  rowTitle: {
    fontSize: "16px",
    fontWeight: 500,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  rowDescription: {
    fontSize: "14px",
    color: "rgba(255, 255, 255, 0.7)",
    lineHeight: 1.5,
  },
  tooltipIcon: {
    display: "inline-flex",
    color: "rgba(255, 255, 255, 0.6)",
    cursor: "help",
  },
  viewerBadge: {
    marginTop: "8px",
    fontSize: "12px",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    color: "#FF80C0",
  },
  channelGroup: {
    display: "flex",
    gap: "4px",
    backgroundColor: "#1F1F1F",
    borderRadius: "12px",
    padding: "2px",
    width: "fit-content",
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      flexDirection: "row",
    },
  },
  channelToggle: {
    flex: "0 0 124px",
    width: "124px !important",
    minWidth: "124px !important",
    maxWidth: "124px !important",
    height: "36px",
    borderRadius: "10px",
    border: "none",
    backgroundColor: "transparent",
    color: "#FFFFFF",
    fontWeight: 600,
    fontSize: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
    },
    [theme.breakpoints.down("sm")]: {
      flex: 1,
      width: "auto !important",
      minWidth: "0 !important",
      maxWidth: "none !important",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  channelActive: {
    background: "#FE5A97",
    borderColor: "#FE5A97",
    color: "#FFFFFF",
    boxShadow: "none",
  },
}));
